export type AlertType = 'success' | 'error' | 'info';

export enum Types {
  success = 'success',
  error = 'error',
  info = 'info',
}
